var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8382_193538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18C11.5823 18 13.129 17.5308 14.4446 16.6518C15.7602 15.7727 16.7855 14.5233 17.391 13.0615C17.9965 11.5997 18.155 9.99113 17.8463 8.43928C17.5376 6.88743 16.7757 5.46197 15.6569 4.34315C14.538 3.22433 13.1126 2.4624 11.5607 2.15372C10.0089 1.84504 8.40034 2.00347 6.93853 2.60897C5.47672 3.21447 4.22729 4.23985 3.34824 5.55544C2.46919 6.87104 2 8.41775 2 10C2.00229 12.121 2.84589 14.1545 4.34568 15.6543C5.84547 17.1541 7.87897 17.9977 10 18ZM10 5.33334C10.1978 5.33334 10.3911 5.39199 10.5556 5.50187C10.72 5.61175 10.8482 5.76793 10.9239 5.95065C10.9996 6.13338 11.0194 6.33445 10.9808 6.52843C10.9422 6.72241 10.847 6.90059 10.7071 7.04044C10.5673 7.1803 10.3891 7.27554 10.1951 7.31412C10.0011 7.35271 9.80004 7.3329 9.61732 7.25722C9.43459 7.18153 9.27841 7.05336 9.16853 6.88891C9.05865 6.72446 9 6.53112 9 6.33334C9 6.06812 9.10536 5.81377 9.29289 5.62623C9.48043 5.43869 9.73478 5.33334 10 5.33334ZM9.33333 8.66667H10C10.3536 8.66667 10.6928 8.80715 10.9428 9.0572C11.1929 9.30724 11.3333 9.64638 11.3333 10V14C11.3333 14.1768 11.2631 14.3464 11.1381 14.4714C11.013 14.5964 10.8435 14.6667 10.6667 14.6667C10.4899 14.6667 10.3203 14.5964 10.1953 14.4714C10.0702 14.3464 10 14.1768 10 14V10H9.33333C9.15652 10 8.98695 9.92977 8.86193 9.80474C8.73691 9.67972 8.66667 9.51015 8.66667 9.33334C8.66667 9.15653 8.73691 8.98696 8.86193 8.86193C8.98695 8.73691 9.15652 8.66667 9.33333 8.66667Z",
    fill: "#112538"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8382_193538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDark);
export default __webpack_public_path__ + "static/media/info-dark.de6067f2b11efcab99a9ee8ebbcd91b9.svg";
export { ForwardRef as ReactComponent };